

import { Component, Prop, Mixins } from 'vue-property-decorator';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component
export default class ThemedCard extends Mixins(DarkThemeInfoMixin) {
    @Prop({ default: '' }) readonly height!: string;
    @Prop({ default: '' }) readonly width!: string;
    @Prop({ default: false }) readonly flat!: boolean;
    @Prop({ default: false }) readonly outlined!: boolean;
    @Prop({ default: false }) readonly hover!: boolean;
    @Prop({ default: '' }) readonly to!: string | object;
}
